<template>
  <v-card>
    <v-card-title>
      Domain &amp; Emails
      <v-spacer></v-spacer>
      <v-btn color="secondary" x-small @click="editDomainsOpen=true;"><v-icon small>edit</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <p class="mb-1 text-caption">Domain Name</p>
          <p><b>{{websiteDetails.domain_name | customPlaceholder}}</b></p>
        </v-col>
        <v-col>
          <p class="mb-1 text-caption">Domain Renewal Date</p>
          <p><b>{{websiteDetails.domain_renewal_date | customPlaceholder}}</b></p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <p class="mb-1 text-caption">Email Addresses {{currentEmailsInUse}}</p>
          <template v-if="websiteDetails.email_addresses===null">
            <p><b>No emails</b></p>
          </template>
          <template v-else>
            <v-chip-group column>
              <template v-for="(item,itemI) in websiteDetails.email_addresses">
                <template v-if="item!==''">
                  <v-chip x-small :key="itemI">{{item}}@{{websiteDetails.domain_name}}</v-chip>
                </template>
              </template>
            </v-chip-group>
          </template>
        </v-col>
      </v-row>
    </v-card-text>
    <DomainAndEmailsDialog :dialogOpen="editDomainsOpen" @close-dialog="editDomainsOpen=false;" />
  </v-card>
</template>

<script>
  import { mapState,mapActions,mapGetters } from "vuex";
  import DomainAndEmailsDialog from './DomainAndEmailsDialog';
  export default {
    components: {DomainAndEmailsDialog},
    data() {
      return { editDomainsOpen: false }
    },
    computed: {
      ...mapState('productWebsite',['websiteDetails']),
      ...mapGetters('productWebsite',['getCurrentProduct','getCurrentAdditionalEmailAddons']),
      currentEmailsInUse(){
        let emails = 0;
        if(this.websiteDetails.email_addresses!==undefined&&this.websiteDetails.email_addresses!==null){
          this.websiteDetails.email_addresses.forEach(email => {
            if(email!==''){ emails++; }
          });
        }
        return `(${emails}/${this.getCurrentAdditionalEmailAddons} used)`;
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
